<template>
  <div class="mainview_div">
    <header class="common--header">
      <b-row class="marginTopAlignment">
        <b-col cols="2" v-on:click="backAction()"><img src="images/Back_white.svg" alt=""/></b-col>
        <b-col cols="8" class="header-title text-center">EDIT PERSONAL DETAILS</b-col>
      </b-row>
    </header>

    <b-container class="personalDetail-contentdiv">
      <b-row>
        <b-col>
          <div class="box">
            <b-form @submit="onSubmit">
              <b-container>
                <p class="add-details__title">{{ this.personalDetailTitle }}</p>
                <div class="floating-form">
                  <div class="personalDetail-floating-label">
                    <select name="Marital Status" class="personalDetail-floating-select" v-model="personalDetails.mrst">
                      <option value="" hidden>- Select -</option>
                      <option v-for="statusValue in lookups.mrst" v-bind:key="statusValue" :value="statusValue">{{ statusValue }}</option>
                    </select>
                    <span class="highlight"></span>
                    <label class="personalDetail-label-field">{{ this.maritalStatus }}</label>
                  </div>

                  <div class="personalDetail-floating-label">
                    <input class="personalDetail-floating-input" type="phone" placeholder=" " v-model="mob" />
                    <span class="highlight"></span>
                    <label class="personalDetail-label-field">Cell Phone</label>
                  </div>

                  <div class="personalDetail-floating-label">
                    <input class="personalDetail-floating-input" type="text" placeholder=" " v-model="personalDetails.adstr" />
                    <span class="highlight"></span>
                    <label class="personalDetail-label-field">Physical Street Address</label>
                  </div>

                  <div class="personalDetail-floating-label">
                    <input
                      class="personalDetail-floating-input"
                      @keyup="getZipdetails(personalDetails.adzip)"
                      type="number"
                      maxlength="5"
                      placeholder=" "
                      v-model="personalDetails.adzip"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    />
                    <span class="highlight"></span>
                    <label class="personalDetail-label-field">Zip</label>
                  </div>

                  <div class="personalDetail-floating-label">
                    <input class="personalDetail-floating-input" type="text" placeholder=" " v-model="personalDetails.adcty" />
                    <span class="highlight"></span>
                    <label class="personalDetail-label-field">City</label>
                  </div>

                  <div class="personalDetail-floating-label">
                    <input class="personalDetail-floating-input" type="text" placeholder=" " v-model="personalDetails.adst" />
                    <span class="highlight"></span>
                    <label class="personalDetail-label-field">State</label>
                  </div>

                  <div class="continue__controls">
                    <b-button type="login" variant="">UPDATE</b-button>
                    <label v-if="errorStatus" class="register_errorMessageLabel" id="errorLabel"> {{ errorMessage }} </label>
                  </div>
                  <label v-if="successStatus" class="errorMessageLabel" id="successLabel"> Details Updated Successfully </label>
                </div>
              </b-container>
            </b-form>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import apiCall from "@/services/api/apicall";
import { store } from "@/store.js";

export default {
  name: "Home",
  components: {},
  data() {
    return {
      store: store,
      mob: "",
      errorStatus: false,
      errorMessage: "",
      lookups: {},
      personalDetails: {},
      successStatus: false,
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.successStatus = false;
      if (this.mob.length == 0) {
        this.errorStatus = true;
        this.errorMessage = "Cell number cannot be empty";
      } else if (this.mob.length < 11) {
        this.errorStatus = true;
        this.errorMessage = "Cell number is not valid";
      } else {
        if (navigator.onLine) {
        this.errorStatus = false;
        this.personalDetails.mob = this.mob;
        var header = {};
        //   headers: [
        //     {
        //       key: "Content-Type",
        //       value: "application/json",
        //       type: "text",
        //     },
        //   ],
        // };

        apiCall
          .apiServiceCall("Post", "", "/user", this.personalDetails, header)
          .then(response => {
              if (response.data.status == 1) {
                this.store.userDetails = this.personalDetails;
                this.successStatus = true;
              } else {
                this.errorStatus = true;
                this.errorMessage = response.data.message;
              }
          })
          .catch(error => {
            if (error.response.status == 500) {
              this.errorStatus = true;
              this.errorMessage = this.serverProblem;
            } else if (error.response.status == 401) {
              setTimeout(() => this.$router.push({ path: "/home" }), 2000);
            } else if (error.response.status == 504) {
              this.signout();
            }  else {
              this.errorStatus = true;
              this.errorMessage = error.response.data.message;
            }
          });

        } else {
          this.errorStatus = true;
          this.errorMessage = this.checkInternetConnection;
        }
      }
    },
    backAction() {
      this.$router.push({ path: "/app-home" });
    },
    getZipdetails(zipcode) {
      if (zipcode.length >= 5) {
        if (navigator.onLine) {
        var header = {};//[];
        apiCall
          .apiServiceCall("GetOne", "", "/lookup/zip/" + zipcode, "", header)
          .then(response => {
              if (response.data.status == 1) {
                this.personalDetails.adcty = response.data.data.cty;
                this.personalDetails.adst = response.data.data.st;
              } else {
                this.errorStatus = true;
                this.errorMessage = response.data.message;
              }
          })
          .catch(error => {
            if (error.response.status == 500) {
              this.errorStatus = true;
              this.errorMessage = this.serverProblem;
            } else if (error.response.status == 401) {
              setTimeout(() => this.$router.push({ path: "/home" }), 2000);
            }  else if (error.response.status == 504) {
              this.signout();
            } else {
              this.errorStatus = true;
              this.errorMessage = error.response.data.message;
            }
          });

        } else {
          this.errorStatus = true;
          this.errorMessage = this.checkInternetConnection;
        }
      }
    },
  },
  mounted() {
    if (navigator.onLine) {
    //Api call to fetch the dropdown list
    apiCall
      .apiServiceCall("Get", "", "/lookup/", "", "")
      .then(response => {
          if (response.data.status == 1) {
            //Setting respective values to the dropdown
            this.lookups = response.data.data;
            //Api call to fetch personal details
            apiCall
              .apiServiceCall("GetOne", store.registration.iid, "/user/", "", "")
              .then(response => {
                  if (response.data.status == 1) {
                    this.personalDetails = response.data.data;
                    this.mob = this.personalDetails.mob;
                  } else {
                    this.errorStatus = true;
                    this.errorMessage = response.data.message;
                  }
              })
              .catch(error => {
                if (error.response.status == 500) {
                  this.errorStatus = true;
                  this.errorMessage = this.serverProblem;
                } else if (error.response.status == 401) {
                  setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                } else if (error.response.status == 504) {
                  this.signout();
                }  else {
                  this.errorStatus = true;
                  this.errorMessage = error.response.data.message;
                }
              });
          } else {
            this.errorStatus = true;
            this.errorMessage = response.data.message;
          }
      })
      .catch(error => {
        if (error.response.status == 500) {
          this.errorStatus = true;
          this.errorMessage = this.serverProblem;
        } else if (error.response.status == 401) {
          setTimeout(() => this.$router.push({ path: "/home" }), 2000);
        } else if (error.response.status == 504) {
            this.signout();
        }  else {
          this.errorStatus = true;
          this.errorMessage = error.response.data.message;
        }
      });

    } else {
      this.errorStatus = true;
      this.errorMessage = this.checkInternetConnection;
    }
  },
};
</script>
